<template>
  <div>
    <button
      class="home-btn"
      @click="homeAction"
      :style="{ 'background-color': globe.backgroundColor }"
    >
      <img src="@/images/home-ico.svg" />
    </button>
  </div>
</template>

<script>
import BackToPrintStoreMixin from '@/features/printstore/BackToPrintStoreMixin'

export default {
  data() {
    return {}
  },
  mixins: [BackToPrintStoreMixin],
  computed: {
    globe() {
      return this.rootStore.globe
    },
    fromPrintStore() {
      if (
        this.rootStore.previousRoute === 'printstore' &&
        this.$route.name === 'printOrder'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    homeAction() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-btn svg:deep(g) {
  fill: var(--sub-color);
}
</style>
